import React, { useState } from "react";
import { ThinTextField } from "../../common/GeneralComponent";

const VisualVerification = ({ data }) => {
  const [showInfraModal, setShowInfraModal] = useState(false);
  const [showSignageModal, setShowSignageModal] = useState(false);

  if (!data) {
    return (
      <div className="text-center py-8 text-gray-500">No data available</div>
    );
  }

  const photoInfrastructure = data.photo_of_infrastructure || null;
  const photoInfraTaken = data.photo_of_infrastructure_taken || "No";
  const photoSignage = data.photo_showing_signage || null;
  const photoSignageTaken = data.photo_showing_signage_taken || "No";

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "";
    const cleanPath = imagePath.replace(/^undefined\//, "");
    if (cleanPath.startsWith("http://") || cleanPath.startsWith("https://")) {
      return cleanPath;
    }
    const baseUrl = process.env.REACT_APP_BASE_URL || "";
    return `${baseUrl}/${cleanPath}`;
  };

  const handleInfraClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (photoInfrastructure) setShowInfraModal(true);
  };

  const closeInfraModal = (e) => {
    e?.stopPropagation();
    setShowInfraModal(false);
  };

  const handleSignageClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (photoSignage) setShowSignageModal(true);
  };

  const closeSignageModal = (e) => {
    e?.stopPropagation();
    setShowSignageModal(false);
  };

  return (
    <div className="bg-white rounded p-4">
      <form className="w-full">
        {/* First Row - Photo Taken Status, Empty, Empty */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <ThinTextField
            isRequired={false}
            label="Photo of infrastructure taken?"
            value={photoInfraTaken}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="Photo showing signage or use by community?"
            value={photoSignageTaken}
            disabled
          />
          <div className="w-full"></div>
        </div>

        {/* Second Row - Photo Viewers */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          {photoInfraTaken === "Yes" && photoInfrastructure && (
            <div className="w-full">
              <label className="text-sm font-[Regular] text-[#565656] mb-1 block">
                Infrastructure Photo
              </label>
              <div className="border border-gray-300 rounded-md p-2 bg-gray-50 h-[42px] flex items-center">
                <button
                  onClick={handleInfraClick}
                  className="flex items-center gap-2 cursor-pointer hover:bg-blue-50 px-2 py-1 rounded transition-all duration-200 border border-transparent hover:border-blue-200 w-full text-left min-h-0"
                >
                  <i className="fa fa-image text-blue-500 text-sm flex-shrink-0"></i>
                  <span className="text-xs text-blue-600 hover:text-blue-800 font-medium truncate">
                    View Infrastructure Photo
                  </span>
                  <i className="fa fa-eye text-xs text-blue-400 flex-shrink-0 ml-auto"></i>
                </button>
              </div>
            </div>
          )}
          {photoSignageTaken === "Yes" && photoSignage && (
            <div className="w-full">
              <label className="text-sm font-[Regular] text-[#565656] mb-1 block">
                Signage Photo
              </label>
              <div className="border border-gray-300 rounded-md p-2 bg-gray-50 h-[42px] flex items-center">
                <button
                  onClick={handleSignageClick}
                  className="flex items-center gap-2 cursor-pointer hover:bg-blue-50 px-2 py-1 rounded transition-all duration-200 border border-transparent hover:border-blue-200 w-full text-left min-h-0"
                >
                  <i className="fa fa-image text-blue-500 text-sm flex-shrink-0"></i>
                  <span className="text-xs text-blue-600 hover:text-blue-800 font-medium truncate">
                    View Signage Photo
                  </span>
                  <i className="fa fa-eye text-xs text-blue-400 flex-shrink-0 ml-auto"></i>
                </button>
              </div>
            </div>
          )}
          <div className="w-full"></div>
        </div>
      </form>

      {/* Image Modals */}
      {showInfraModal && photoInfrastructure && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[9999]"
          onClick={closeInfraModal}
        >
          <div
            className="relative bg-white rounded-lg shadow-lg p-4 max-w-3xl max-h-[90vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeInfraModal}
              className="absolute top-2 right-2 text-gray-600 hover:text-black"
            >
              ✕
            </button>
            <h2 className="text-center text-gray-800 mb-3 text-lg font-semibold">
              Infrastructure Photo
            </h2>
            <img
              src={getImageUrl(photoInfrastructure)}
              alt="Infrastructure Photo"
              className="max-h-[80vh] object-contain rounded-md border border-gray-300"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src =
                  "https://via.placeholder.com/600x400?text=Image+not+found";
              }}
            />
            <a
              href={getImageUrl(photoInfrastructure)}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:text-blue-700 text-sm underline mt-2 text-center"
            >
              View Full Image
            </a>
          </div>
        </div>
      )}

      {showSignageModal && photoSignage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[9999]"
          onClick={closeSignageModal}
        >
          <div
            className="relative bg-white rounded-lg shadow-lg p-4 max-w-3xl max-h-[90vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeSignageModal}
              className="absolute top-2 right-2 text-gray-600 hover:text-black"
            >
              ✕
            </button>
            <h2 className="text-center text-gray-800 mb-3 text-lg font-semibold">
              Signage Photo
            </h2>
            <img
              src={getImageUrl(photoSignage)}
              alt="Signage Photo"
              className="max-h-[80vh] object-contain rounded-md border border-gray-300"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src =
                  "https://via.placeholder.com/600x400?text=Image+not+found";
              }}
            />
            <a
              href={getImageUrl(photoSignage)}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:text-blue-700 text-sm underline mt-2 text-center"
            >
              View Full Image
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default VisualVerification;